<template lang="pug">
table-base.study-result-detail-table
  table-row-base.study-result-detail-table__row
    table-header-base.study-result-detail-table__row__header.align-center
      slot(name='problemNumberHeader')
    table-header-base.study-result-detail-table__row__header.align-center
      slot(name='questionNumberHeader')
    table-header-base.study-result-detail-table__row__header.align-center
      slot(name='correctSymbolHeader')
    //- 正答率は一時的に非表示
    //- table-header-base.study-result-detail-table__row__header.align-center
    //-   slot(name='correctRateHeader')
  table-row-base.study-result-detail-table__row(v-for='(detail, index) in studyResultDetails', :key='`id_${index}`')
    table-data-base.study-result-detail-table__row__cell.align-center {{ detail.problemNumberText }}
    table-data-base.study-result-detail-table__row__cell.align-center {{ detail.questionNumberText }}
    table-data-base.study-result-detail-table__row__cell.align-center {{ detail.correctSymbol }}
    //- 正答率は一時的に非表示
    //- table-data-base.study-result-detail-table__row__cell.align-center {{ detail.correctRate }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import TableBase from '@/components/atoms/TableBase.vue'
import TableRowBase from '@/components/atoms/TableRowBase.vue'
import TableHeaderBase from '@/components/atoms/TableHeaderBase.vue'
import TableDataBase from '@/components/atoms/TableDataBase.vue'
import { StudyResultDetailType } from '@/models/studyResultDetailModel'

/**
 * テスト結果詳細テーブル
 */
@Component({
  components: {
    TableBase,
    TableRowBase,
    TableHeaderBase,
    TableDataBase,
  },
})
export default class StudyResultDetailTable extends Vue {
  // テスト結果詳細表示情報
  @Prop()
  studyResultDetails!: StudyResultDetailType[]
}
</script>

<style lang="stylus" scoped>
.study-result-detail-table
  width 100%

  &__row
    &__header, &__cell
      width 25%
      border 1px solid var(--color-study-list-table__border)

    &__header
      padding 5px
      background-color var(--color-study-list-head__background)
      color var(--color-study-list-head__text)

    &__cell
      padding 10px
</style>
